<template>
  <div id="app">
    <!-- <el-menu
      :default-active="this.$route.path"
      mode="horizontal"
      background-color="black"
      text-color="#fff"
      center
      :router=true
      class="nav"
      active-text-color="#409eff">
      <el-menu-item index="/in_process">In_process</el-menu-item>
      <el-menu-item index="/verfied_by_title">verfied_group_by_title</el-menu-item>
      <el-menu-item index="/verfied_by_site">verfied_group_by_site</el-menu-item>
    </el-menu> -->

    <div class="nav">
      <router-link to="/in_process">
        <button class="nav_button">In process</button>
      </router-link>
	  <router-link to="/monitoring">
	    <button class="nav_button">Monitoring</button>
	  </router-link>
      <router-link to="/upload_excel">
        <button class="nav_button">Upload excel</button>
      </router-link>
      <router-link to="/verfied_by_title">
        <button class="nav_button">Verfied group by title</button>
      </router-link>
      <router-link to="/verfied_by_site">
        <button class="nav_button">Verfied group by site</button>
      </router-link>
      <!-- <router-link to="/twitch_game">
        <button class="nav_button">twitch_game</button>
      </router-link> -->
      <div class="user-div">{{user}}</div>

      <div class="login-div">
        <el-input placeholder="" v-model="pwd" class="login-input" size="mini" @change="login()">
          <el-select v-model="usr" slot="prepend" placeholder="User" style="width: 6rem;">
            <el-option v-for="item in usr_options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-button slot="append" icon="el-icon-user" @click="login()" >Change User</el-button>
        </el-input>
      </div>



    </div>
    <router-view/>

  </div>

</template>
<script>
export default {
  name: 'App',
  data() {
        return {
          user:localStorage.getItem('user'),
          usr:'',
          pwd:'',
          usr_options: [{
            value: 'admin',
            label: 'Admin'
          }, {
            value: 'Alice',
            label: 'Alice'
          }, {
            value: 'Bella',
            label: 'Bella',
          }, {
            value: 'Cyrus',
            label: 'Cyrus'
          }, {
            value: 'Diana',
            label: 'Diana',
          }, {
            value: 'Eva',
            label: 'Eva'
          }, {
            value: 'Fiona',
            label: 'Fiona',
          }, {
            value: 'Gina',
            label: 'Gina',
          }, {
            value: 'Helen',
            label: 'Helen',
          }, {
            value: 'Irene',
            label: 'Irene',
          }, {
            value: 'Jana',
            label: 'Jana',
          }, {
            value: 'Karis',
            label: 'Karis',
          }, {
            value: 'Lila',
            label: 'Lila',
          }, {
            value: 'Maura',
            label: 'Maura',
          }, {
            value: 'Nikki',
            label: 'Nikki',
          }, {
            value: 'Oreo',
            label: 'Oreo',
          }, {
            value: 'Paula',
            label: 'Paula',
          }, {
            value: 'Q',
            label: 'Q',
          }, {
            value: 'Rose',
            label: 'Rose',
          }, {
            value: 'Sofia',
            label: 'Sofia',
          }, {
            value: 'Tony',
            label: 'Tony',
          }],
        };

      },
  methods:{
    login:function(){
      var that = this
      this.$axios({
          method: 'POST',
          url: '/api/login/',
          data: {
            username: that.usr,
            password: that.pwd,
          }
        })
        .then(response => {
          if (0 == response.data.code) {
            localStorage.setItem('user',that.usr)
            that.pwd = ''
            that.user = localStorage.getItem('user')
          }else{
            this.$message.error('密码错误，请重新登录')
            localStorage.removeItem('Authorization')
            this.$router.push('/login')
            // localStorage.setItem('user','')
          }
        })
    },
  }

}
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  font-family: "Microsoft YaHei","微软雅黑";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  background-color: white;
  position: absolute;
  top: 0rem;
  left: 0rem;
  z-index: 10;

},
.title{
    position: absolute;
    top: 0.4rem;
    text-align: right;
    width: 90%;
    font-size: xx-large;
    color: white;
    background-color: #000000;
    z-index: -1;
  }
.nav{
  height: 2.5rem;
  line-height: 2.5rem;
  font-family: "microsoft yahei","微软雅黑";
}
.nav{
  position: relative;
  width: 100%;
  top:0rem;
  text-align: left;
  color: azure;
  z-index: 1;
  background-color: #7f7f7f;
}
.user-div{
  position: absolute;
  top:0rem;
  right: 26.25rem;
  margin: 0rem;
  margin-right: 0.5rem;
  padding: 0rem;
  border: 0rem;
  height: 1.5rem;
  width: 5rem;
}
.login-div{
  position: absolute;
  top:0rem;
  right: 1.25rem;
  margin: 0rem;
  margin-right: 0.5rem;
  padding: 0rem;
  border: 0rem;
  height: 1.5rem;
  width: 25rem;
}
.login-input{
}
.nav_button{
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
  top:0rem;
  left: 1.25rem;
  margin: 0rem;
  margin-right: 0.5rem;
  padding: 0rem;
  border: 0rem;
  height: 1.5rem;
  width: 10rem;
  border-radius:  0.625rem 0rem 0.625rem 0rem;
  box-shadow: 0.3rem 0rem 0rem azure;
  color: #000000;
  background-color: #e6e6e6;
  outline-style: none;
}
.nav_button:hover{
  background-color: #ffffff;
  color: black;
  box-shadow: 0.3rem 0.3rem 0rem #996633;
}
.nav_button:active{
  background-color: #000000;
  color: white;
  box-shadow: 0.3rem 0.3rem 0rem #ffffff;
}

</style>



// WEBPACK FOOTER //
// src/App.vue